import { login } from '@pesto/features';

import { routes } from '../constants/routes';

const LoginCallback = () => {
  return (
    <login.AuthCallbackPage
      defaultRedirectPath={routes.dashboard}
      loginPath={routes.login}
      loginCallbackPath={routes.loginCallback}
    />
  );
};

export default LoginCallback;
